import type { TranslateFunction } from "../types/index.js";
import { parseDate } from "./date.js";
import { formatDayMonth } from "./format-date.js";

const MINUTE_MS = 60_000;
const HOUR_MS = 3_600_000;
const DAY_MS = 86_400_000;
const DAYS_BEFORE_ABSOLUTE_DATE = 30;

export function formatNotificationTime(date: Date | string, t: TranslateFunction, language: string): string {
	const parsed = parseDate(date);
	if (!parsed) return "";
	const diffMs = Date.now() - parsed.getTime();
	const diffMin = Math.floor(diffMs / MINUTE_MS);
	const diffHours = Math.floor(diffMs / HOUR_MS);
	const diffDays = Math.floor(diffMs / DAY_MS);

	if (diffMin < 1) return t("time.just_now");
	if (diffMin < 60) return t("time.minutes_ago", { count: diffMin });
	if (diffHours < 24) return t("time.hours_ago", { count: diffHours });
	if (diffDays < DAYS_BEFORE_ABSOLUTE_DATE) return t("time.days_ago", { count: diffDays });

	return formatDayMonth(parsed, language);
}
